import type { PIPOutboundTarget, PIPTarget } from './types'

const pipTarget: PIPTarget[] = ['_self', '_blank']
const pipOutboundTarget: PIPOutboundTarget[] = ['_blank', '_self', '_top']

export const pipParamsConfig = {
  stringParams: [],
  numberParams: [],
  boolParams: ['pip', 'pip_navigate', 'pip_observe'],
  enumParams: {
    pip_target: pipTarget,
    pip_outbound_target: pipOutboundTarget,
  },
} as const
